import React from "react";

import TextComposer from "./Composer/TextComposer";
import VoiceComposer from "./Composer/VoiceComposer";
import PhotoComposer from "./Composer/PhotoComposer";
import VideoComposer from "./Composer/VideoComposer";

import Modal from "./Modal";

const CreateComment = ({ isOpen, isClose, postType, postId }) => {
  return (
    <Modal isOpen={isOpen} isClose={isClose} title="Create a comment">
      <div className="z-30 w-full px-2 py-3 sm:px-4">
        {postType === "text" && <TextComposer mode="comment" postId={postId} postType={postType} close={isClose} />}
        {postType === "voice" && <VoiceComposer mode="comment" postId={postId} postType={postType} close={isClose} />}
        {postType === "photo" && <PhotoComposer mode="comment" postId={postId} postType={postType} close={isClose} />}
        {postType === "video" && <VideoComposer mode="comment" postId={postId} postType={postType} close={isClose} />}
      </div>
    </Modal>
  );
};

export default CreateComment;